import { slavtUrl } from "../api/config";
import { Video } from "../models/Video";
import { Cue } from "./vtt";

type Sortable = {
  startTime: string;
};

export function sortByStartTime(itemA: Sortable, itemB: Sortable) {
  const time1 = new Date(`1970-01-01T${itemA.startTime}.001Z`);
  const time2 = new Date(`1970-01-01T${itemB.startTime}.001Z`);

  return time1 < time2 ? -1 : time1 > time2 ? 1 : 0;
}

/**
 * Returns a hash code from a string
 * @param  {String} str The string to hash.
 * @return {Number}    A 32bit integer
 * @see http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 */
export function hash(str: string) {
  let hash = 0;
  for (let i = 0, len = str.length; i < len; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

export function getElapsedFromStart(startTime: string) {
  const [hh, mm, ss] = startTime.split(":");
  const [seconds] = ss.split(".").map(Number);

  return parseInt(hh) * 3600 + parseInt(mm) * 60 + seconds;
}

function timeToSeconds(time: string): number {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

export function countOverlaps(
  startTime: string,
  endTime: string,
  cues: Cue[],
): number {
  const startSeconds = timeToSeconds(startTime);
  const endSeconds = timeToSeconds(endTime);

  return cues.filter((cue) => {
    const cueStartSeconds = timeToSeconds(cue.startTime);
    const cueEndSeconds = timeToSeconds(cue.endTime);

    return startSeconds < cueEndSeconds && endSeconds > cueStartSeconds;
  }).length;
}

export function maxCharactersFor20CPS(
  startTime: string,
  endTime: string,
): number {
  if (!startTime || !endTime) return 0;

  const startSeconds = timeToSeconds(startTime);
  const endSeconds = timeToSeconds(endTime);

  // Calculate duration in seconds
  const duration = endSeconds - startSeconds;

  // If duration is zero or negative (invalid time range), return 0
  if (duration <= 0) return 0;

  // Calculate max characters for 20 CPS
  const maxCharacters = duration * 20;

  return Math.min(Math.floor(maxCharacters), 48); // return as an integer (max whole number of characters)
}

export function getVideoUrl(video: Video) {
  return video.isExternal ? video.url : `${slavtUrl}/buckets/${video.url}`;
}
